import { render, staticRenderFns } from "./psp-request-setting.vue?vue&type=template&id=875e9df2"
import script from "./psp-request-setting.vue?vue&type=script&lang=js"
export * from "./psp-request-setting.vue?vue&type=script&lang=js"
import style0 from "./psp-request-setting.vue?vue&type=style&index=0&id=875e9df2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports